// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "dirty": false,
    "raw": "d69eb26",
    "hash": "d69eb26",
    "distance": null,
    "tag": null,
    "semver": null,
    "suffix": "d69eb26",
    "semverString": null,
    "version": "20.0.10",
    "date": "2026-03-03T10:09:51.781Z"
};
/* tslint:enable */
